module.exports = __webpack_public_path__ + "img/lianghualogo.b61e8cfa.svg";